import script from "./Recuperar.vue?vue&type=script&setup=true&lang=js"
export * from "./Recuperar.vue?vue&type=script&setup=true&lang=js"

import "./Recuperar.vue?vue&type=style&index=0&id=26abe6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26abe6b8"]])

export default __exports__